import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib/cn';
import { Button, type ButtonColor } from './Button';

interface PanelHeaderProps {
  title: string;
  titleClassName?: string | undefined;
  className?: string | undefined;
  closeColor?: ButtonColor | undefined;
  onClose: () => void;
}

export const PanelHeader = ({
  title,
  titleClassName,
  className,
  closeColor,
  onClose,
}: PanelHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn('flex items-center justify-between gap-3', className)}>
      <h2
        className={cn(
          'm-0 font-display text-lg font-semibold leading-tight text-ink',
          titleClassName,
        )}
      >
        {title}
      </h2>
      <Button
        aria-label={t('actions.close')}
        className={closeColor != null ? 'rounded-full' : undefined}
        color={closeColor ?? 'neutral'}
        iconOnly
        leadingIcon={<X size={16} />}
        onClick={onClose}
        size="sm"
        variant={closeColor != null ? 'soft' : 'ghost'}
      />
    </div>
  );
};
